import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=2f73858a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f73858a')) {
      api.createRecord('2f73858a', component.options)
    } else {
      api.reload('2f73858a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=2f73858a&", function () {
      api.rerender('2f73858a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4cbF6juT703ja/JS/comp/ImgFallback.vue"
export default component.exports